import { def } from '@goldblack/shared';

const optionsFilterType = ['exact', 'between'];

const optionsFilterSelection = ['0', '1', '2', '3', '4', '5'];

const optionsFilterWidth = [
    '1',
    '1.5',
    '2',
    '2.5',
    '3',
    '3.5',
    '4',
    '4.5',
    '5',
    '5.5',
    '6',
    '6.5',
    '7',
    '7.5',
    '8',
    '8.5',
    '9',
    '9.5',
    '10',
    '10.5',
    '11',
    '12',
];

const optionsUserStatus = [
    { label: 'Active', code: def.UserStatus.ACTIVE },
    { label: 'Inactive', code: def.UserStatus.INACTIVE },
    { label: 'Invisible', code: def.UserStatus.INVISIBLE },
    { label: 'Blocked', code: def.UserStatus.BLOCKED },
    { label: 'NotVerified', code: def.UserStatus.NOT_VERIFIED },
];

const optionsSearch = [
    { label: 'name', code: 'name' },
    { label: 'email', code: 'email' },
];

const optionsReport = [
    { label: 'Fake profile or scammer', code: 'Fake profile or scammer' },
    { label: 'Fake or AI generated photo', code: 'Fake or AI generated photo' },
    { label: 'Nudity or sexually explicit', code: 'Nudity or sexually explicit' },
    { label: 'Not a photo of this user', code: 'Not a photo of this user' },
];

const optionsBlockExpires = [
    { label: '1 day', code: def.UserBlockExpires.DAY_1 },
    { label: '3 days', code: def.UserBlockExpires.DAY_3 },
    { label: '5 days', code: def.UserBlockExpires.DAY_5 },
    { label: '7 days', code: def.UserBlockExpires.DAY_7 },
    { label: '14 days', code: def.UserBlockExpires.DAY_14 },
    { label: '28 days', code: def.UserBlockExpires.DAY_28 },
    { label: 'Infinite', code: def.UserBlockExpires.INFINITE },
];

const optionsBlockReasons = [
    { label: 'Max following hit', code: def.UserBlockReasons.MAX_FOLLOWING_HIT },
    { label: 'Max chat message hit', code: def.UserBlockReasons.MAX_CHATMESSAGE_HIT },
    { label: 'Fake profile or scammer', code: def.UserBlockReasons.FAKE_PROFILE_OR_SCAMMER },
    { label: 'Fake or AI generated photo', code: def.UserBlockReasons.FAKE_OR_AI_GENERATED_PHOTO },
    {
        label: 'Nudity or sexually explicit',
        code: def.UserBlockReasons.NUDITY_OR_SEXUALLY_EXPLICIT,
    },
    { label: 'Not a photo of this user', code: def.UserBlockReasons.NOT_A_PHOTO_OF_THIS_USER },
];

const optionsInactiveForced = [
    { label: 'True', code: 1 },
    { label: 'False', code: 0 },
];

const optionsInactiveReasons = [
    { label: 'Max following hit', code: def.UserBlockReasons.MAX_FOLLOWING_HIT },
    { label: 'Max chat message hit', code: def.UserBlockReasons.MAX_CHATMESSAGE_HIT },
    { label: 'Fake profile or scammer', code: def.UserBlockReasons.FAKE_PROFILE_OR_SCAMMER },
    { label: 'Fake or AI generated photo', code: def.UserBlockReasons.FAKE_OR_AI_GENERATED_PHOTO },
    {
        label: 'Nudity or sexually explicit',
        code: def.UserBlockReasons.NUDITY_OR_SEXUALLY_EXPLICIT,
    },
    { label: 'Not a photo of this user', code: def.UserBlockReasons.NOT_A_PHOTO_OF_THIS_USER },
];

const optionsBadgeStatus = [
    { label: 'Active', code: def.BadgeStatus.ACTIVE },
    { label: 'Inactive', code: def.BadgeStatus.INACTIVE },
];

const optionsFilterGroup = [
    { label: 'Search', code: def.FilterGroup.SEARCH },
    { label: 'Trending', code: def.FilterGroup.TRENDING },
    { label: 'Admin', code: def.FilterGroup.ADMIN },
    { label: 'Recommend', code: def.FilterGroup.RECOMMEND },
    { label: 'Explore', code: def.FilterGroup.EXPLORE },
];

const optionsFilterOptionAttribute = [{ label: 'Trending', code: def.FilterOptionAttribute.TRENDING }];

const optionsMessageSetStatus = [
    { label: 'Active', code: 0 },
    { label: 'Inactive', code: 1 },
];

const optionsMessageTheme = [
    { label: 'Dark', code: 'dark' },
    { label: 'Light', code: 'light' },
];

const optionsSubscriptionStatus = [
    { label: 'Active', code: 'active' },
    { label: 'Inactive', code: 'inactive' },
    { label: 'Cancelled', code: 'cancelled' },
    { label: 'Expired', code: 'expired' },
];

const optionsSubscriptionPlan = [
    { label: 'Basic', code: 'basic' },
    { label: 'Premium', code: 'premium' },
];

export {
    optionsFilterType,
    optionsFilterSelection,
    optionsFilterWidth,
    optionsSearch,
    optionsUserStatus,
    optionsReport,
    optionsBlockExpires,
    optionsBlockReasons,
    optionsInactiveForced,
    optionsInactiveReasons,
    optionsBadgeStatus,
    optionsFilterGroup,
    optionsFilterOptionAttribute,
    optionsMessageSetStatus,
    optionsMessageTheme,
    optionsSubscriptionStatus,
    optionsSubscriptionPlan,
};
